import React from 'react';

export const styles = () => {
  return {
    generalContainer: {
      display: 'flex',
      flexDirection: 'column' as 'column',
      justifyContent: 'flex-start' as 'flex-start',
      alignItems: 'flex-start' as 'flex-start',
      gap: 8,
      backgroundColor: 'transparent',
      width: '100%',
      alignSelf: 'stretch' as 'stretch',
    } as React.CSSProperties,
    listItemContainer: {
      display: 'flex',
      flexDirection: 'row' as 'row',
      justifyContent: 'space-between',
      alignItems: 'center' as 'center',
      gap: 12,
      alignSelf: 'stretch' as 'stretch',
      padding: '16px 12px',
      flexWrap: 'wrap' as 'wrap',
    } as React.CSSProperties,
    listItemLeftContainer: {
      display: 'flex',
      flexDirection: 'row' as 'row',
      justifyContent: 'flex-start' as 'flex-start',
      alignItems: 'center' as 'center',
      gap: 12,
      flex: 1,
    } as React.CSSProperties,
    notificationContainer: {
      display: 'flex',
      flexDirection: 'column' as 'column',
      justifyContent: 'center' as 'center',
      alignItems: 'center' as 'center',
      cursor: 'pointer',
    } as React.CSSProperties,
  };
};
